// extracted by mini-css-extract-plugin
export default {"shimmerLoader":"Shimmer_shimmerLoader__0bZXD","shimmerAnimation":"Shimmer_shimmerAnimation__CYGcI"};